import { useTranslation } from 'react-i18next';
import Icon from 'src/components/Icon';
import useCustomHistory from 'src/hooks/useCustomHistory';

export default function QuickMenu(): JSX.Element {
  const { t } = useTranslation();
  const menuData = [
    {
      icon: 'ticket_b',
      name: t('home/quickmenu_my_product_title'),
      path: '/product/my',
    },
    {
      icon: 'notice',
      name: t('notice/title'),
      path: '/notice',
    },
    {
      icon: 'account',
      name: t('home/quickmenu_my_info_title'),
      path: '/user',
    },
    {
      icon: 'customer',
      name: t('home/quickmenu_customer_center_title'),
      path: '/customer',
    },
    {
      icon: 'faq',
      name: t('home/quickmenu_faq_title'),
      path: '/faq',
    },
  ];
  const menuList = menuData.map((data) => {
    const history = useCustomHistory();
    return (
      <button
        key={data.icon}
        className="w-1/3 flex justify-center items-start"
        onClick={() => {
          history.push(data.path);
        }}
      >
        <div className="flex flex-col justify-center items-center w-26 py-3.5">
          <Icon name={data.icon} size="32" />
          <p className="N_12_M mt-2 text-greyish-brown">{data.name}</p>
        </div>
      </button>
    );
  });
  return <div className="flex flex-wrap w-full mt-3.5">{menuList}</div>;
}
